import React, { useEffect, useRef, useState } from "react";
import Modal from "../../components/Modal";
import Checkbox from "../../components/Checkbox";
import Table, { Column, TableHandle } from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { PropertyType } from "../../redux/slices/PropertyType/slice";
import { Button } from "../../components/Button";
import { FaEdit } from "react-icons/fa";
import { LightColors } from "../../utils/colors/colors";
import { useNavigate } from "react-router-dom";
import { AreaType, setFilterData } from "../../redux/slices/AreaManagement/slice";
import AddArea from "./components/AddArea";
import { fetchAreaList } from "../../redux/slices/AreaManagement/thunk";
import FilterForm from "./components/FilterForm";

const AreaManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const tableRef = useRef<TableHandle>(null);

  const {
    loading,
    filterData,
    paginationData,
    areaList
  } = useSelector((state: RootState) => state.area)

  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedArea, setSelectedArea] = useState<AreaType | null>(null)
  const [refresh, setRefresh] = useState(false)



  // Table columns for User
  const columns: Column<AreaType>[] = [
    { key: "area", label: "Area Name", sortable: true, },
    { key: "city", label: "City", sortable: true, },
    { key: "state", label: "State", sortable: true, },
    {
      key: "isActive",
      label: "Active",
      sortable: false,
      customCell: (row) => (
        <div className='flex'>
          <Checkbox checked={row?.isActive} onCheckedChange={function (checked: boolean): void {

          }} />

        </div>

      ),
    },
    {
      key: "action",
      label: "Actions", // Use a label or empty string if preferred
      sortable: false,
      customCell: (row) => (
        <div className='flex'>
          <a
            className="text-blue-600 cursor-pointer"
            onClick={() => {
              setSelectedArea(row)
              setShowAddModal(true)
            }}
            role="button"
            tabIndex={0}
          >
            <FaEdit color={LightColors.accent} size={20} />
          </a>
        </div>

      ),
    },
  ];

  useEffect(() => {
    dispatch(fetchAreaList({
      ...filterData
    }))
  }, [
    filterData.page,
    filterData.isActive,
    filterData.limit,
    filterData.city,
    filterData.state,
    filterData.search,
    filterData.sortBy,
    filterData.sortOrder,
    refresh
  ]
  );

  return (
    <div>
      <Table
        ref={tableRef}
        columns={columns as any}
        data={areaList}
        tableName="Area managment"
        totalCount={filterData.totalCount}
        currentPage={filterData.page}
        pageSize={filterData.limit}
        loading={loading.areaList}
        filterContent={<FilterForm
          tableRef={tableRef}
        />}
        onSearchChange={(searchText) => {
          dispatch(setFilterData({ ...filterData, search: searchText, page: 1 }));
        }}
        onPageChange={(page) => {
          dispatch(setFilterData({
            ...filterData,
            page: page,
          }))
        }}
        onPageSizeChange={function (size: number): void {
          dispatch(setFilterData({
            ...filterData,
            limit: size,
            page: 1
          }))
        }}
        renderRightToolItems={
          <div className='flex gap-2'>

            <Button
              variant="primary"
              onClick={() => setRefresh(!refresh)}
            >
              Refresh
            </Button>
            <Button variant="primary" onClick={() => { setShowAddModal(true) }}>
              Add
            </Button>
          </div>
        }
      />

      <AddArea
        setShowAddModal={setShowAddModal}
        isOpen={showAddModal}
        initialData={selectedArea as any}
        mode={selectedArea ? "edit" : "add"}
        onSubmit={(data: any) => {
          setSelectedArea(null);
          dispatch(fetchAreaList({
            ...filterData
          }))
        }}
        onCancel={function (): void {
          setSelectedArea(null);
        }} />
    </div>
  )
}

export default AreaManagement
